export enum IndividualWithoutShortageTokens {
  CLINICO = 'bhJfBDp', //714 inativo
  DOC = 'y0c6NN9', //789 inativo
  ORTO = 's501FqS', //712 inativo
  PROTESE = 'TlWnqLm', //795 inativo
}

export enum IndividualWithShortageTokens {
  CLINICO = 'LKKzNlc', //709
  CLINICONA = '5DtF7Uy', //948 NA
  DOC = 'b6Qgseq', //945 NA
  ORTO = 'MHUPnXO', //713
  PROTESE = 'N94uYbj', //796 NA
  KIDS = 'n5J4pNI', //937
  CLINICO_AN = 'p2wEboC', //989
  DOC_AN = 'VKDdNPP', //991 NA
  PROTESE_AN = 'ClYmJHs', //992 NA
  UNI = 'jU8zuuX',
}
export enum IndividualWithShortageIds {
  CLINICO = '709',
  CLINICONA = '948',
  DOC = '945',
  ORTO = '713',
  PROTESE = '796',
  KIDS = '937',
  CLINICO_AN = '989',
  DOC_AN = '991',
  PROTESE_AN = '992',
  UNI = 'jU8zuuX',
}

export enum IndividualWithShortageNorthEastTokens {
  CLINICO = 'cE2zhsI', //1011 NE
  CLINICO_AN = 'S7170js', //1012 CC
  DOC = '8WfoLai', //1013 NE
  DOC_AN = '5l0S5I7', //1014 CC
  ORTO = 'xuUghgE', //1015 NE
  ORTO_AN = 'gxO8PiS', //1016 CC
  PROTESE = 'q8xpZGb', //1017 NE
  PROTESE_AN = 'b8XMNXA', //1018 CC
  KIDS = 'QyJHmtQ', //1019 NE
  KIDS_AN = 'uvVKHnw', //1020 CC
  UNI = 'jU8zuuX',
}
export enum IndividualWithShortageNorthEastIds {
  CLINICO = '1011', //'cE2zhsI', //1011 NE
  CLINICO_AN = '1012', //'S7170js', //1012 CC
  DOC = '1013', //'8WfoLai', //1013 NE
  DOC_AN = '1014', //'5l0S5I7', //1014 CC
  ORTO = '1015', //'xuUghgE', //1015 NE
  ORTO_AN = '1016', //'gxO8PiS', //1016 CC
  PROTESE = '1017', //'q8xpZGb', //1017 NE
  PROTESE_AN = '1018', //'b8XMNXA', //1018 CC
  KIDS = '1019', //'QyJHmtQ', //1019 NE
  KIDS_AN = '1020', //'uvVKHnw', //1020 CC
  UNI = 'jU8zuuX',
}

export enum BussinessTypeRangeLives1Tokens {
  CLINICO = 'oKq5BIe', //923
  CLINICO_NE = 'RZSU3jM', //1025
  DOC = 'JzzNwnl', //864
  DOC_NE = 'H7rLsD2', //1023
  ORTO = 'XnNj1rk', //720
  ORTO_NE = 'Ro4dRqc', //1021
}
export enum BussinessTypeRangeLives1Ids {
  CLINICO = '923', //719
  CLINICO_NE = '1025', //1025
  DOC = '864', //864
  DOC_NE = '1023', //1023
  ORTO = '720', //720
  ORTO_NE = '1021', //1021
}

export enum BussinessTypeRangeLives2Tokens {
  CLINICO = 'IsI7djS', //721
  CLINICO_NE = 'vNGasst', //1026
  DOC = 'rGUCEGO', //866
  DOC_NE = 'TV8yrgM', //1024
  ORTO = 'smjRgCfFD', //722
  ORTO_NE = 'EL58VxM', //1022
}
export enum BussinessTypeRangeLives2Ids {
  CLINICO = '721',
  CLINICO_NE = '1026',
  DOC = '866',
  DOC_NE = '1024',
  ORTO = '722',
  ORTO_NE = '1022',
}

export enum Id_Products { // _NA = Nacional _NE = Nordeste _AN = Anual
  CLINICO_NA = 709,
  DOC_NA = 945,
  PROTESE_NA = 796,
  CLINICO_NA_AN = 989,
  DOC_NA_AN = 991,
  PROTESE_NA_AN = 992,
  CLINICO_NE = 947,
  CLINICO_NE_AN = 990,
}
